import { Button, Colors, Flex, Text } from '@revenuemarket/cds';

import { CertificateRegisterType } from './CertificateSection';

const EmptyCertificateSection = ({
  setType,
}: {
  setType: (type: CertificateRegisterType) => void;
}) => {
  return (
    <Flex
      direction="column"
      gap={8}
      align="center"
      justify="center"
      style={{
        borderRadius: 16,
        border: '1px solid rgba(29, 34, 37, 0.04)',
        background: Colors.gray30,
        width: '100%',
        padding: '24px 16px',
      }}
    >
      <Text textStyle="14_500" style={{ color: Colors.gray800, textAlign: 'center' }}>
        저장된 공동인증서를 찾지 못했어요.
        <br />
        파일을 직접 선택해 주세요.
      </Text>
      <Button border onClick={() => setType(CertificateRegisterType.FIND)}>
        직접 선택
      </Button>
    </Flex>
  );
};

export default EmptyCertificateSection;
